import { gql } from 'apollo-angular';

export const GET_STATIONARY_PURCHASE_DETAILS = gql`
  query getStationoryPurchaseDetails($stationoryId: Int!) {
    getStationoryPurchaseDetails(stationoryId: $stationoryId) {
      supplierId
      supplierName
      quantityBought
      date
      unitPrice
      subTotal
      tax
      total
    }
  }
`;

export const GET_STATIONARY_ITEM_LOGS = gql`
  query getStationoryItemsLogs($stationoryId: Int!, $startDate: String, $endDate: String) {
    getStationoryItemsLogs(stationoryId: $stationoryId, startDate: $startDate, endDate: $endDate) {
      stationoryId
      date
      stationoryData {
        id
        stationoryName
        stationoryCode
        price
        stock
        status
      }
      openingStock
      closingStock
      status
    }
  }
`;
